import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const FAQWrap = ({ blok }) => {
  return (
    <div className="wrap">
    <div className="faq-wrap inner-wrap"{...storyblokEditable(blok)}>
        <div className="faq-top">
      <h2 className="text-2xl">{blok.subheadline} </h2>
    </div>
    <div className="faq-wrap-contentwrap">
      {blok.question.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))} 
    </div>
            
</div>
</div>
  );
};

export default FAQWrap;